export const IOS = 'iOS';
export const ANDROID = 'Android';
export const CHROME = 'Chrome';
export const IOS_MIN_VERSION = 14.3;
export const ANDROID_MIN_VERSION = 7;
export const CHROME_MIN_VERSION = 59;
export const FB_BOT_WIDTH_SIZE = 2000;
export const FB_BOT_HEIGHT_SIZE = 2000;
export const DEVICE_OS = {
    ANDROID: 'ANDROID',
    IOS: 'IOS',
    MAC_OS: 'MAC OS',
    DEFAULT: 'DEFAULT_DEVICE',
};
